import { fun_PostAction } from "@/api/index";
// 引入公共方法
import { fun_GetKeys } from "@/utils/validate";
import CaLock from "@/components/common/calock";
export default {
  data() {
    return {
      // 列表loading初始状态
      loading: false,
      // 表头温馨提示
      btnList: [
        {
          name: "解绑",
          type: "danger",
          icon: "delete"
        }
      ],
      // 查询表单字段
      form: {
        id: null, // 主键
        userName: null, // 用户名称
        phoneNumber: null, // 手机号码
        lockNo: null, // 锁编号
        digitalSignature: null // 数字签名
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "用户名称：",
          value: "userName",
          width: "150",
          placeholder: "请输入"
        },
        {
          type: "input",
          label: "手机号码：",
          value: "phoneNumber",
          placeholder: "请输入"
        }
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "姓名",
          prop: "userName"
        },
        {
          label: "手机号码",
          prop: "phoneNumber"
        },
        {
          label: "申请时间",
          prop: "insertDate"
        },
        {
          label: "状态",
          prop: "stateName"
        },
        {
          label: "操作",
          slotName: "op"
        }
      ],
      // 表格数据
      tableData: [],
      // 温馨提示
      tipList: [
        /*{
          type: "text",
          text: "（1）用户绑定成功后可在武招通公众号中进行招投标业务办理，请仔细核对用户信息再绑定；",
        },
        {
          type: "text",
          text: "（2）用户从当前企业离职后，请及时将该用户业务办理权限进行解绑操作；",
        },
        {
          type: "text",
          text: "（3）用户不负责当前企业招投标业务时，请将该用户业务办理权限进行冻结操作。",
        },*/
      ],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      multipleSelection: [], // 勾选的数组
      operationType: null // 操作类型
    };
  },
  // 注册组件
  components: {
    // ca弹窗
    CaLock
  },
  mounted() {
    // 获取用户绑定一览
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 初始化方法
     * @author shuhua
     */
    fun_GetList() {
      // 发起请求
      fun_PostAction("/corpUserBinding/list", {}).then(res => {
        // 结构res.data
        const { result, data } = res.data;
        // 操作成功
        if (result) {
          // 列表数据
          this.tableData = data.records;
          //  总条数
          this.total = data.total;
        }
      });
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 滕威
     */
    fun_click(e) {
      switch (e) {
        case "解绑":
          // 解除绑定
          this.fun_OpenCaDialog("", "del");
          break;
      }
    },
    /**
     * 打开ca弹窗
     * @author shuhua
     */
    fun_OpenCaDialog(val, type) {
      // 操作类型
      this.operationType = type;
      // 删除时
      if (type === "del") {
        // 存在勾选数据
        if (this.multipleSelection && this.multipleSelection.length > 0) {
          // 操作标识
          var rtn = false;
          // 遍历
          this.multipleSelection.map(item => {
            // 状态为未绑定
            if (item.state === "2") {
              // 修改标识
              rtn = true;
            }
          });
          // 存在未绑定信息
          if (rtn) {
            // 未勾选，则提示
            this.$alert(
              "选择解绑的用户中存在未绑定用户，请重新选择！",
              "warning"
            );
            return;
          }
          // 开启弹窗
          this.$refs.caLock.dialogCalock = true;
          // 签名数据
          this.$refs.caLock.data =
            this.multipleSelection[0].userName +
            this.multipleSelection[0].phoneNumber +
            this.multipleSelection[0].corpId;
          // 状态
          this.$refs.caLock.state = "tj";
        } else {
          // 未勾选，则提示
          this.$alert("请选择一条数据！", "warning");
          return;
        }
      } else {
        // 主键
        this.form.id = val.id;
        // 开启弹窗
        this.$refs.caLock.dialogCalock = true;
        // 签名数据
        this.$refs.caLock.data = val.userName + val.phoneNumber + val.corpId;
        // 状态
        this.$refs.caLock.state = "tj";
      }
    },
    /**
     * 保存或修改的方法
     * @author shuhua
     */
    fun_SaveOrUpdate(state, lockNo, digitalSignature) {
      // ca弹窗关闭
      this.$refs.caLock.dialogCalock = false;
      this.form.lockNo = lockNo;
      this.form.digitalSignature = digitalSignature;
      // 删除
      if (this.operationType === "del") {
        // 绑定的方法
        this.fun_Del();
      } else {
        // 提交的方法（绑定，取消冻结，冻结）
        this.fun_Submit();
      }
    },
    /**
     * 绑定的方法
     * @author shuhua
     */
    fun_Submit() {
      // 发起请求
      fun_PostAction("/corpUserBinding/saveOrUpdate", {
        ...this.form,
        state: this.operationType
      }).then(res => {
        // 结构res.data
        const { result, msg } = res.data;
        // 操作成功
        if (result) {
          // 重新加载一览
          this.fun_GetList();
          // 提示操作成功
          this.$message.success(msg);
        } else {
          // 错误提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 解除绑定
     * @author shuhua
     */
    fun_Del() {
      // 获取keys
      const keys = fun_GetKeys(this.multipleSelection);
      // 发起请求，获取结果集
      fun_PostAction("/corpUserBinding/delete?keys=" + keys).then(res => {
        // 解构res.data
        const { result, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 查询列表
          this.fun_GetList();
          // 提示删除成功
          this.$message.success(msg);
        } else {
          // 请求失败，提示信息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 勾选事件
     * @author shuhua
     */
    fun_HandleSelectionChange(e) {
      // 赋值
      this.multipleSelection = e;
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    }
  }
};
